import type { MemoizedSelector } from '@ngrx/store';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import type { ViewsState } from './views.state';
import type { AppState } from '../app-reducers';

export const SELECT_VIEW_STATE = createFeatureSelector<ViewsState>('views');

// profile
export const SELECT_PROFILE_IMAGE = createSelector(
  SELECT_VIEW_STATE,
  (state) => state.profileImage
);

export const SELECT_PROFILE = createSelector(SELECT_VIEW_STATE, (state) => state.profile);

// profile settings
export const SELECT_PROFILE_SETTINGS = createSelector(
  SELECT_VIEW_STATE,
  (state) => state.pricingSettings
);

//toggle assign driver dialog on assign from booking management
export const SELECT_IS_ASSIGN_DRIVER_OPRN = createSelector(
  SELECT_VIEW_STATE,
  (state) => state.isAssignDriverOpen
);

export const SEELCT_ASSIGN_DRIVER_BOOKING = createSelector(
  SELECT_VIEW_STATE,
  (state) => state.assignDriverBooking
);

// list tabs persistence
export const SELECT_SELECTED_LIST_TABFOR = (
  featureKey: string
): MemoizedSelector<AppState, string | null> =>
  createSelector(
    SELECT_VIEW_STATE,
    (state: ViewsState) => state.selectedListTabs?.[featureKey] ?? null
  );
